<!-- 设备状态管理 -->
<!-- 首页//设备状态统计  -->
<template>
    <div class="box">
      <Title :text="maintain.EquipmentStatistics.Title[0]" :engText="maintain.EquipmentStatistics.Title[1]"></Title>
      <div class="content">
        <div class="a">
          <div class="icon"></div>
          <div class="text-box">
            <div>总数</div>
            <div>1000台</div>
          </div>
        </div>
        <div class="b">
          <div class="echarts-content">
            <chart-block ref="echart"></chart-block>
          </div>
          <div >
            <div>
              <div class="yellow"></div>
              <div class="text">离线数:</div>
              <div class="val">250</div>
            </div>
            <div>
              <div class="blue"></div>
              <div class="text">在线数</div>
              <div class="val">250</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Title from '../../components/title/index.vue';
  import { mapState,mapActions } from 'pinia' //引入映射函数
  import useStore from '@/store/index' //引入store
  export default {
    components: {
      Title,
    },
    computed:{
      ...mapState(useStore,['maintain']) 
    },
    mounted () {
      this.$refs.echart.setOption(this.maintain.EquipmentStatistics.data.option);

    }
  }
  </script>
  
  <style scoped>
  .box{
     width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .content{
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .content .a{
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px;
  }
  .content .a .icon{
    width: 120px;
    height: 110px;
    background: url('@/assets/img/b3.png') no-repeat;
    background-size: 100% 100%;
  }
  .content .a .text-box{
    width: 155px;
    height: 39px;
    background: url("@/assets/img/border2.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    
  }
  .content .a .text-box >div:nth-child(2){
    color: #fff;
  }
  .content .b{
    flex: 1;
    display: flex;
    overflow: hidden;
  }
  .content .b >div:nth-child(1){
    flex: .4;
  }
  .content .b >div:nth-child(2){
    flex: .6;
    display: flex;
    font-size: 12px;
    align-items: center;
    justify-content: space-around;
  }
  .content .b >div:nth-child(2) >div{
    display: flex;
    align-items: center;
    
    margin: 0px 10px;
  }
  .content .b >div:nth-child(2) >div .val{
    color: #fff;
  }
  .yellow{
    width: 10px;
    height: 10px;
    background: #ffb400;
    margin-right: 5px;
  }
  .blue{
    width: 10px;
    height: 10px;
    background: #488dff;
    margin-right: 5px;

  }
  </style>